import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { withPermission, Roles } from "../../../util/PermissionProvider";
import LogoGroupPage from "./LogoGroupPage";
import LogoGroupEditPage from "./LogoGroupPage/editPage";
import LogoGroupGeneralSettingPage from "./LogoGroupGeneralSettingPage";
import LogoListingPage from "./LogoListingPage";
import LogoListingEditPage from "./LogoListingPage/editPage";


export default function LogoPages(props) {
  const { match } = props;
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}/general`}
        component={withPermission(
          LogoGroupGeneralSettingPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        exact
        path={`${match.url}/logo-group`}
        component={withPermission(
          LogoGroupPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/logo-group/:id`}
        component={withPermission(
          LogoGroupEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        exact
        path={`${match.url}/listing`}
        component={withPermission(
          LogoListingPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/listing/:id`}
        component={withPermission(
          LogoListingEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route render={() => <Redirect to={`${match.url}/logo-group`} />} />
    </Switch>
  );
}
